<template>
  <div class="p-grid" style="background-color:#ffffff">
    <Jumbotron urlImage="../../assets/layout/images/bienestar_del_paciente_banner.jpg"
      :title="$t('messages.patientWellness')" :subtitle="$t('messages.patientWellnessDescription')" />
    <div class="container-resizable">
      <div class="p-grid">
        <div class="p-md-12 p-mt-6">
          <h2 class="p-text-center" style="margin-top: 60px;">{{ $t("messages.benefits") }}</h2>
          <div class="container-items">
            <ul>
              <li v-for="(item, index) in itemsCol1" :key="index">{{ item }}</li>              
            </ul>
            <ul>
              <li v-for="item in itemsCol2" :key="item">{{ item }}</li>              
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="p-col-12 contenedor-galeria">
      <GaleriaComponent :images="images" :showLabel="false" />
    </div>
  </div>
</template>

<script>
import Jumbotron from "../layout/jumbotron_main.vue";
import GaleriaComponent from '../layout/galeria.vue'
export default {
  metaInfo: {
    title: 'Beneficios dle paciente - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Beneficios dle paciente - QualityCare',
        content: 'QualityCare ofrece beneficios para los pacientes, para que puedan tener una experiencia agradable y segura',
      },
    ],
  },
  name: "BienestarPacientes",
  components: {
    GaleriaComponent,
    Jumbotron
  },
  data() {
    return {
      images: [
        {
          itemImageSrc: "./assets/layout/gallery/recepcion-2.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recepcion-2-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recepcion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recepcion-1-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recepcion-3.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recepcion-3-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recuperacion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recuperacion-1-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recuperacion-2.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recuperacion-2-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/pasillo-4.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/pasillo-4-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/pasillo-3.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/pasillo-3-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/pasillo-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/pasillo-1-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/salas-pacientes-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/salas-pacientes-1-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/salas-pacientes-2.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/salas-pacientes-2-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/instalaciones-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/instalaciones-1-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recuperacion-3.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recuperacion-3-t.jpg",
          texto: "messages.surgeryRooms",
        }
      ]
    }
  },
  computed: {
    itemsCol1() {
      const translations = {
        es: [
          "Asesor virtual personalizado antes, durante y después de su cirugía.",
          "Habitaciones de recuperación.",
          "Salas de recuperación.",
          "Baños para personas con dificultad en movilidad.",
          "Contamos con un programa de seguridad de paciente enfocado en estándares altos de calidad.",
          "Personal calificado para la atención en las diferentes áreas.",
          "Capacitación continua del personal.",
          "Convenio de alimentación para el postoperatorio.",
        ],
        en: [
          "Personalized virtual advisor before, during and after your surgery.",
          "Recovery rooms.",
          "Recovery rooms.",
          "Bathrooms for people with mobility difficulties.",
          "We have a patient safety program focused on high quality standards.",
          "Qualified personnel for care in different areas.",
          "Continuous training of personnel.",
          "Food agreement for postoperative care.",
        ],
        fr: [
          "Conseiller virtuel personnalisé avant, pendant et après votre chirurgie.",
          "Chambres de récupération.",
          "Salles de récupération.",
          "Salles de bains pour les personnes à mobilité réduite.",
          "Nous avons un programme de sécurité des patients axé sur des normes de qualité élevées.",
          "Personnel qualifié pour les soins dans différents domaines.",
          "Formation continue du personnel.",
          "Accord alimentaire pour les soins postopératoires.",
        ],        
      }
      const lang = this.$i18n.locale;
      return translations[lang];
    },
    itemsCol2() {
      const translations = {
        es: ["Estamos ubicados estratégicamente para suplir las necesidades de cada paciente como hoteles, transporte, restaurantes.",
          "Servicio Humanizado.",
          "Profesionales calificados en las diferentes especialidades los cuales se garantiza la idoneidad.",
          "Servicio de atención al usuario para felicitaciones, quejas y/o sugerencias.",
          "Contamos con el mejor grupo de cirujanos reconocidos a nivel nacional e internacional.",
          "Instalaciones seguras y confortables.",
          "Facilidad de pagos: efectivo, transferencia, tarjeta.",
        ],
        en: [
          "We are strategically located to meet the needs of each patient such as hotels, transportation, restaurants.",
          "Humanized service.",
          "Qualified professionals in different specialties which guarantees suitability.",
          "User service for congratulations, complaints and/or suggestions.",
          "We have the best group of surgeons recognized nationally and internationally.",
          "Safe and comfortable facilities.",
          "Payment facility: cash, transfer, card.",
        ],
        fr: [
          "Nous sommes stratégiquement situés pour répondre aux besoins de chaque patient tels que les hôtels, les transports, les restaurants.",
          "Service humanisé.",
          "Professionnels qualifiés dans différentes spécialités qui garantissent l'adéquation.",
          "Service utilisateur pour félicitations, plaintes et/ou suggestions.",
          "Nous avons le meilleur groupe de chirurgiens reconnus nationalement et internationalement.",
          "Installations sûres et confortables.",
          "Facilité de paiement : espèces, virement, carte.",
        ],
      }
      const lang = this.$i18n.locale;
      return translations[lang];      
    }
  }
};
</script>

<style lang="scss" scoped>
.container-resizable {
  justify-content: center;
  background-color: #FFFFFF;
}

h2 {
  color: #083078;
  font-size: 40px;
  font-weight: bolder;
}

.contenedor-galeria {
  padding: 20px 300px;
  background-color: #FFFFFF;
}

.container-items {
  display: flex;
}

ul {
  font-size: 20px;

  li {
    margin-top: 20px;
  }
}

.image {
  width: auto;
  height: 250px;
}

@media screen and (max-width: 1540px) {
  .container-resizable {
    padding: 30px 10px;
  }
}

@media screen and (max-width: 1200px) {
  .contenedor-galeria {
    padding: 20px 10px;
  }

  .image {
    width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 955px) {
  h2 {
    margin-top: 30px;
  }

  .container-items {
    display: block;
  }
}
</style>